const getters = {
  slideList: state => state.slideList,
  handleSize: state => state.handleSize,
  handleCurrent: state => state.handleCurrent,
  CallCenterStatusObj: state => state.CallCenterStatusObj,
  CallOutRextendData: state => state.CallOutRextendData,
  activationPointCount: state => state.activationPointCount,
  exportFileStatus: state => state.exportFileStatus,
};
export default getters;
